const cdServerUrl = "https://cce.scu.edu.cn/mana/web";
// const cdServerUrl = "http://211.83.158.74/mana/web";
const moduleDetailUrl="https://cce.scu.edu.cn/mana/view";
export default {
    cdServerUrl,
    moduleDetailUrl
}

